import axios from 'axios';

const USERS_API = `${process.env.VUE_APP_API_URL}/v1/users`;

export const getUser = () => axios.get(`${USERS_API}/me`).then((result) => result.data.user);
export const selectLocale = (locale) => axios.patch(`${USERS_API}/locale`, { locale });
